module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent"
  }, [_c('sticky', {
    attrs: {
      "scroll-box": "vux_view_box_body",
      "offset": 46
    }
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        preventGoBack: true,
        showBack: true
      }
    },
    on: {
      "on-click-back": _vm.goHome
    }
  }), _vm._v(" "), _c('tab', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.index),
      expression: "index"
    }],
    attrs: {
      "line-width": 2,
      "active-color": "#fc378c"
    },
    domProps: {
      "value": (_vm.index)
    },
    on: {
      "input": function($event) {
        _vm.index = $event
      }
    }
  }, _vm._l((_vm.list2), function(item) {
    return _c('tab-item', {
      staticClass: "vux-center",
      attrs: {
        "selected": _vm.demo2 === item
      },
      on: {
        "click": function($event) {
          _vm.demo2 = item
        },
        "on-item-click": function($event) {
          _vm.handler(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view', {
    staticClass: "child-view"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-3683b69e!./~/.1.0.35@vux-loader/src/template-loader.js!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailHead.vue
// module id = 258
// module chunks = 2